export const DateTimeStringFormat = 'yyyy-MM-dd HH:mm:ss';
export const DateTimeStringFormatWithoutSeconds = 'yyyy-MM-dd HH:mm';
export const DateTimeStringFormatWithZone = 'yyyy-MM-dd HH:mm:ssXXX';
export const DateStringFormat = 'yyyy-MM-dd';
export const DateStringDottedFormat = 'dd.mm.yy.';
export const WeekdayDayMonthYearFullFormat = 'EEEE, dd MMMM yyyy';
export const WeekdayDayOrdinalMonthYearFullFormat = 'EEEE, do MMMM yyyy';
